import { render, staticRenderFns } from "./seller-order.page.vue?vue&type=template&id=3573f47a&scoped=true"
import script from "./seller-order.page.vue?vue&type=script&lang=js"
export * from "./seller-order.page.vue?vue&type=script&lang=js"
import style0 from "./seller-order.page.vue?vue&type=style&index=0&id=3573f47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3573f47a",
  null
  
)

export default component.exports